import React, { ReactText } from 'react';
import { Data, DropDownProps } from '../type';
import GroupByOrderByTimeFormatGroup from './GroupByOrderByTimeFormatGroup';
import OnlyShowDetailsCheckbox from './OnlyShowDetailsCheckbox';
import { Divider } from 'elmo-elements';

export type DataProps = {
  handleOnChangeSelect: (e: DropDownProps, name: string) => void;
  handleOnChangeCheckbox: (e: any) => void;
  handleOnChangeTimeFormat: (value: ReactText) => void;
  data: Data;
};

const CommonExtraGroup = ({
  data,
  handleOnChangeSelect,
  handleOnChangeCheckbox,
  handleOnChangeTimeFormat,
}: DataProps) => {
  return (
    <>
      <Divider />
      <br />
      <h3>View</h3>
      <GroupByOrderByTimeFormatGroup
        data={data}
        handleOnChangeSelect={handleOnChangeSelect}
        handleOnChangeTimeFormat={handleOnChangeTimeFormat}
      />
      <OnlyShowDetailsCheckbox
        data={data}
        handleOnChangeCheckbox={handleOnChangeCheckbox}
      />
    </>
  );
};

export default CommonExtraGroup;
